<template>
  <b-container>
    <h2 class="text-center" v-show="!error">
      <span v-show="!downloaded"><translate>Downloading file...</translate></span>
      <span v-show="downloaded"><translate>File downloaded ok!</translate></span>
    </h2>
    <h2 class="text-center" v-show="error">
      <translate>There were errors downloading the file :(</translate>
    </h2>
    <spinner v-if="!downloaded" />
  </b-container>
</template>

<script>
import Spinner from '@/components/Spinner'

export default {
  name: 'DownloadFromApi',
  components: {
    Spinner
  },
  data() {
    return {
      downloaded: false,
      error: false
    }
  },
  props: {
    url: {
      type: String,
      default: null,
      required: false
    },
    badLinkPart2: {
      type: String,
      default: null,
      required: false
    },
    badLinkPart3: {
      type: String,
      default: null,
      required: false
    }
  },
  created() {
    if (this.badLinkPart2) {
      window.location.href = '/download?f=' + this.url + '/' + this.badLinkPart2 + '/' + this.badLinkPart3
    }
  },
  mounted() {
    let urlParam
    if (this.url) {
      urlParam = this.url
    } else if (this.$route.query.f) {
      urlParam = this.$route.query.f
    }
    if (!this.badLinkPart2) {
      this.$http.get(this.$appConfig.api.baseUrl + urlParam.replace(/~/g, '.'), {responseType: 'blob'})
        .then(response => {
          try {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')

            // FIXME: when backend add `response.setHeader("Access-Control-Expose-Headers", "Content-Disposition")` to response it should be used for filename instead of this hack
            let filename = urlParam.replace(/~/g, '.').split('/')[(urlParam.split('/').length - 1)]
            filename = filename.indexOf('.') !== -1 ? filename : filename + '.' + response.data.type.split('/')[response.data.type.split('/').length - 1]

            link.href = url
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
            link.remove()
            window.URL.revokeObjectURL(url)
            this.downloaded = true
          } catch (e) {
            this.error = true
            this.downloaded = true
          }
        })
    }
  }
}
</script>
